/** Manual WhatsApp links (no API, no sync, no auto-send). Shared by the dashboard shortcut and contact actions.
 *  Only an already-reviewed, structured E.164 number is accepted — nothing is guessed (no default +91), and a
 *  well-formed number is NOT proof the number uses WhatsApp. Names, emails and history never go into the URL. */
export const WHATSAPP_WEB_URL = "https://web.whatsapp.com/";
export const BUSINESS_WHATSAPP_LABEL = "Business WhatsApp · +91 98400 68999";
export const WHATSAPP_WEB_HELP = "Opens WhatsApp Web. The sender is whichever WhatsApp account is signed in on this browser; ONE cannot set it through a link. Sign in with +91 98400 68999. Sent manually; ONE does not sync this chat.";
export const MANUAL_NOTE = "Manual chat you start yourself. This is not marketing consent and records none; ONE sends and logs nothing.";
export const NEW_TAB = { target: "_blank", rel: "noopener noreferrer" };

const E164 = /^\+[1-9][0-9]{7,14}$/; // ASCII digits only: rejects spaces, extensions, Unicode digits, separators, query/fragment injection

export function waMeUrl(e164) {
  if (typeof e164 !== "string" || !E164.test(e164)) return null;
  return `https://wa.me/${e164.slice(1)}`;
}

/** Decide whether "Open in WhatsApp" is available for a contact the user can already see. */
export function contactWhatsApp(contact) {
  if (!contact) return { ok: false, reason: "Contact not available." };
  if (contact.suppressed || contact.whatsapp_enabled === false) return { ok: false, reason: "This contact is suppressed or opted out of WhatsApp." };
  if (contact.wa_number_opted_out !== false) return { ok: false, reason: contact.wa_number_opted_out ? "This number opted out of WhatsApp. Do not message it." : "Opt-out status not loaded; link withheld." };
  const denied = Object.entries(contact.consent || {}).filter(([, v]) => v?.status === "DENIED").map(([k]) => k);
  if (denied.length) return { ok: false, reason: `Consent DENIED (${denied.join(", ")}). Manual link withheld; review the contact first.` };
  const pref = contact.preferred_phone;
  if (!pref) {
    const many = (contact.phones || []).length > 1;
    return { ok: false, reason: many ? "Choose the reviewed preferred number first (this contact has several numbers)." : "No reviewed preferred number yet. Review the contact's number first." };
  }
  if (typeof pref !== "string" || !pref.startsWith("+")) return { ok: false, reason: "The preferred number has no country code. Add it in the contact review — ONE does not guess one." };
  const url = waMeUrl(pref);
  if (!url) return { ok: false, reason: "The preferred number is not a valid international number. Fix it in the contact review." };
  return { ok: true, url, note: MANUAL_NOTE };
}
